import { Webhook } from '@mui/icons-material';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import SupervisedUserCircleRoundedIcon from '@mui/icons-material/SupervisedUserCircleRounded';
import { Box } from '@mui/material';
import { CallerType } from 'api/models/Common/JyrneyEnums';
import FallbackButton from 'components/Voice/FallbackButton';
import { BookingDetailsProps } from '../BookingStatusPage';
import { panelActionButtonSx } from './panelActionStyles';

type EntryProps = {
  icon?: JSX.Element
  name: string
  contactNumber?: string
  jobId?: string
}

const Entry = ({ icon, name, contactNumber, jobId }: EntryProps) => (
  <Box
    component="div"
    sx={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '0.313rem',
    }}
  >
    {icon}
    <Box component="p" sx={{ padding: 0, margin: 0, fontSize: '0.75rem' }}>
      {name}
    </Box>
    {contactNumber && jobId && (
      <FallbackButton
        label={name}
        number={contactNumber}
        id={jobId}
        type={CallerType.PASSENGER}
        sx={panelActionButtonSx}
      />
    )}
  </Box>
)

const PassengerDetails = ({ selectedJob }: BookingDetailsProps) => {
  const leadPassenger =
    selectedJob?.passengers?.filter(
      (passenger: any) => passenger.isLeadPassenger === true,
    ) || ''
  return (
    <Box
      component="div"
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.625rem',
        backgroundColor: '#EDEDED',
      }}
    >
      <Entry
        icon={<SupervisedUserCircleRoundedIcon />}
        name={leadPassenger[0]?.name || ''}
        contactNumber={leadPassenger[0]?.contactNumber}
        jobId={selectedJob?.id}
      />

      <Entry
        icon={<ApartmentRoundedIcon />}
        name={selectedJob?.client?.companyName || ''}
      />

      <Entry
        icon={
          selectedJob?.booker?.firstName && selectedJob?.booker?.firstName ? (
            <ManageAccountsRoundedIcon />
          ) : (
            <Webhook />
          )
        }
        name={
          `${selectedJob?.booker?.firstName ?? 'Automated'} ${
            selectedJob?.booker?.lastName ?? 'Booking'
          }` || ''
        }
        contactNumber={selectedJob?.booker?.contactNumber}
        jobId={selectedJob?.id}
      />
    </Box>
  )
}

export default PassengerDetails
